import { jsx as e } from "react/jsx-runtime";
import { useStepsContext as r } from "./useStepsContext.mjs";
import { Typography as p } from "../../dataDisplay/Typography/Typography.mjs";
const n = ({ children: o }) => {
  const { componentClassPrefix: t } = r();
  return /* @__PURE__ */ e(p, { className: `${t}__step-label`, children: o });
};
export {
  n as StepLabel
};
